import { useEffect, useState } from "react";
import api from "./api";

const KEY = "cs_seo_v1";
const PRIVATE = ["/panier", "/commander", "/payment", "/suivi", "/compte", "/favoris", "/connexion", "/admin", "/apercu-maintenance"];
let cache = (() => { try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; } })();
let inflight = null;
let fresh = false;
const subs = new Set();

const load = () => {
  if (fresh || inflight) return inflight;
  inflight = api.get("/seo/meta").then((r) => {
    cache = r.data; fresh = true;
    try { localStorage.setItem(KEY, JSON.stringify(r.data)); } catch { /* quota */ }
    subs.forEach((f) => f(cache));
  }).catch(() => {}).finally(() => { inflight = null; });
  return inflight;
};

export function useSeoMap() {
  const [m, setM] = useState(cache);
  useEffect(() => { subs.add(setM); load(); return () => { subs.delete(setM); }; }, []);
  return m;
}

export const isPrivatePath = (p) => PRIVATE.some((x) => p === x || p.startsWith(`${x}/`));

export const sessionId = () => {
  let sid = localStorage.getItem("cs_session");
  if (!sid) { sid = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("cs_session", sid); }
  return sid;
};

export const trackEvent = (name, label = "") => {
  api.post("/track/event", { name, label: String(label || "").slice(0, 120), session: sessionId(), path: window.location.pathname }).catch(() => {});
};

const TYPE_LABEL = { cookie: "Cookie", brownie: "Brownie", cupcookie: "Cupcookie", prepared_box: "Box", box: "Box" };
const clip = (t, n = 155) => { const s = String(t || "").replace(/\s+/g, " ").trim(); return s.length <= n ? s : `${s.slice(0, n - 1).replace(/\s+\S*$/, "")}…`; };

export const productSeoTitle = (p) => {
  if ((p.seo_title || "").trim()) return p.seo_title.trim();
  const name = (p.name || "").trim();
  if (p.limited_edition) return `${name} · Édition limitée · Crunchy Sweet`;
  const label = TYPE_LABEL[p.type] || "Gourmandise";
  return name.toLowerCase().includes(label.toLowerCase()) ? `${name} fait maison · Crunchy Sweet` : `${name} · ${label} artisanal · Crunchy Sweet`;
};

export const productSeoDesc = (p) => {
  if ((p.seo_desc || "").trim()) return clip(p.seo_desc);
  let base = clip(p.tagline || p.description || p.name, 150);
  if (base.length < 90) base = clip(`${base.replace(/[.…]+$/, "")}.${p.pickup_only ? " Fait main à Palaiseau, à retirer sur place." : " Fait main à Palaiseau, en retrait ou livraison."}`);
  return base;
};
